import React from 'react';
import { selectPageModelSE0 } from 'store/pageModel';
import { useSelector } from 'react-redux';
import { textStyles } from './style';
import { Container } from '../container';

type SEOTextProps = {
	className?: string;
};

export const SEOText = ({ className = '' }: SEOTextProps) => {
	const pageModelSEO = useSelector(selectPageModelSE0);
	const seotext = pageModelSEO?.seotext || '';

	return (
		<Container className={`${textStyles} ${className}`.trimRight()}>
			<section dangerouslySetInnerHTML={{ __html: seotext }} />
		</Container>
	);
};
